import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { AnalyticsDashboard } from '../components/AnalyticsDashboard';

export function Analytics() {
  const { user } = useAuth();

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <AnalyticsDashboard />;
} 